import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

class RescheduleOverlapController extends Controller {
  static targets = ['mechanic', 'startsAt', 'endsAt', 'warning']
  static values = {
    appointments: Object,
    currentId: Number
  }

  connect () {
    this.check()
  }

  check () {
    const mechanicId = this.mechanicTarget.value
    const startsAt = this.startsAtTarget.value
    const endsAt = this.endsAtTarget.value

    if (!mechanicId || !startsAt || !endsAt) {
      this.hideWarning()
      return
    }

    const appointments = this.appointmentsValue[mechanicId] || []
    const overlapping = appointments.filter(appt => {
      if (appt.id === this.currentIdValue) return false
      return appt.starts_at < endsAt && appt.ends_at > startsAt
    })

    if (overlapping.length > 0) {
      this.showWarning(overlapping)
    } else {
      this.hideWarning()
    }
  }

  showWarning (overlapping) {
    const items = overlapping.map(appt => {
      const customer = appt.customer || '—'
      return `<div class="flex items-center justify-between gap-2 text-xs">
        <span class="font-medium">${customer}</span>
        <span class="tabular-nums text-amber-700 font-semibold">${appt.starts_at} – ${appt.ends_at}</span>
      </div>`
    }).join('')

    this.warningTarget.innerHTML = `
      <div class="rounded-lg border border-amber-300 bg-amber-50 p-3 space-y-2">
        <div class="flex items-center gap-1.5">
          <svg class="w-4 h-4 text-amber-600 shrink-0" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
          </svg>
          <span class="text-xs font-semibold text-amber-800">Пересечение с записями (${overlapping.length})</span>
        </div>
        <div class="space-y-1">${items}</div>
      </div>
    `
    this.warningTarget.classList.remove('hidden')
  }

  hideWarning () {
    this.warningTarget.classList.add('hidden')
    this.warningTarget.innerHTML = ''
  }
}

stimulus.register('reschedule-overlap', RescheduleOverlapController)
